import * as React from 'react';
import { Dropdown, Menu, Modal, message, Button } from 'antd';
import { ClickParam } from 'antd/lib/menu';
import { isString } from 'util';

import ImageCmp, { ImageItem, getUrl } from './Image';
import RenderInBody from '../RenderInBody';
import defaultUrl from '../../assets/default.png';
import styles from './index.less';

const defaultProps = {
  size: 30,
  images: [] as ImageItem[],
};
const themeColor = process.env.THEME_COLOR;
const red = '#FF1717';

type DefaultProps = typeof defaultProps;
type Props = DefaultProps & {
  size?: number;
  onDelete?: (images: ImageItem[]) => {};
  imageProps?: React.ImgHTMLAttributes<HTMLImageElement>;
} & React.DOMAttributes<HTMLAnchorElement>;

export default class DokImage extends React.PureComponent<Props> {
  static defaultProps = defaultProps;
  state = {
    index: -1,
  };
  render() {
    const { size, imageProps, images, onDelete, ...restProps } = this.props;
    const { index } = this.state;

    if (!images.length) {
      images.push(defaultUrl);
    }
    return (
      <>
        {onDelete ? (
          <Dropdown
            placement="bottomCenter"
            overlay={
              <Menu className={styles['image-menu']} onClick={this.handlePictureChange}>
                <Menu.Item key="preview" style={{ color: themeColor }}>
                  {' '}
                  预览{' '}
                </Menu.Item>
                {!!onDelete && (
                  <Menu.Item key="delete" style={{ color: red }}>
                    删除{images && images.length > 1 && '全部'}
                  </Menu.Item>
                )}
              </Menu>
            }
            {...restProps}
          >
            <div>
              <ImageCmp size={size} images={images} imageProps={imageProps} />
            </div>
          </Dropdown>
        ) : (
          <div onClick={() => this.setState({ index: 0 })}>
            <ImageCmp size={size} images={images} imageProps={imageProps} />
          </div>
        )}
        {index >= 0 && (
          <RenderInBody>
            <div id="mask" className={styles.mask} onClick={this.handleClose}>
              <div className={styles['mask-content']}>
                {images && images[index] && <img alt="图片" src={getUrl(images[index])} />}
              </div>
              {!!onDelete && (
                <Button type="danger" onClick={this.handleDelete}>
                  删除本图
                </Button>
              )}
              {images && images.length > 1 && (
                <div className={styles['file-list']}>
                  {images.map((v, i) => (
                    <div key={i} onClick={() => this.setState({ index: i })}>
                      <img
                        key={index}
                        src={getUrl(v)}
                        alt={(isString(v) ? v : v.name) || '图片'}
                        style={{ borderColor: index === i ? themeColor : 'transparent' }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </RenderInBody>
        )}
      </>
    );
  }
  // 预览 / 删除全部
  handlePictureChange = ({ key }: ClickParam) => {
    const { images, onDelete } = this.props;

    switch (key) {
      case 'preview':
        this.setState({ index: 0 });
        break;
      case 'delete':
        if (images.length > 1) {
          Modal.confirm({
            title: '确定要删除全部图片吗？',
            onOk: async () => {
              if (onDelete) {
                await onDelete([]);
                message.success('操作成功！');
              }
            },
            okText: '删除',
            okButtonProps: {
              style: {
                borderColor: red,
                backgroundColor: red,
              },
            },
          });
        } else {
          onDelete && onDelete([]);
        }
        break;
      default:
        break;
    }
  };
  // 关闭预览
  handleClose = (e: any) => {
    if (e.target.matches('div#mask')) {
      this.setState({ index: -1 });
    }
  };
  // 删除本图
  handleDelete = async () => {
    const { images, onDelete } = this.props;
    const { index } = this.state;
    if (onDelete) {
      const img = images.filter((v, i) => i !== index);
      await onDelete(img);
      const len = img.length;
      this.setState({
        index: len > index ? index : len - 1,
      });
    }
  };
}
